module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/readable-stream/passthrough.js
// module id = ../../../../readable-stream/passthrough.js
// module chunks = common